import PrivilegioService from '@/services/PrivilegioService'

export const privilegio = {
  namespaced: true,
  actions: {
    newPrivilegio () {
      return PrivilegioService.newPrivilegio()
    },
    getAllPrivilegio () {
      return PrivilegioService.getAllPrivilegio()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    getPrivilegio ({ id }) {
      return PrivilegioService.getPrivilegio(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    postPrivilegio ({ payload }) {
      return PrivilegioService.postPrivilegio(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    postPrivilegioRetornar ({ dispatch }, payload) {
      return PrivilegioService.postPrivilegioRetornar(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    putPrivilegio ({ dispatch }, payload) {
      return PrivilegioService.putPrivilegio(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            return Promise.reject(new Error(error))
          }
        )
    },
    deletePrivilegio ({ dispatch }, id) {
      return PrivilegioService.deletePrivilegio(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            return Promise.reject(new Error(error))
          }
        )
    },
  },
  state: {},
  mutations: {},
}
